import { v4 as uuid } from "uuid";
import {
  image1,
  image6,
  image7,
  image8,
  image9,
  image10,
  item7,
  item8, 
  item9
} from "assets/images/index";

export const products = [
  {
    _id:"3704667f-4abc-4c22-bbdd-0a4bdbd52d99",
    name: "Madhubani Art",
    image: image7,
    ratings: 5,
    price: 399,
    original: 1299,
    discounted: 80,
    description: "Exclusively from Bihar",
    categoryName: "painting",
  },
  {
    _id: "ee46b756-2402-4002-b158-2243b5bd7e8d",
    name: "Toy Car",
    image: image1,
    ratings: 3,
    price: 199,
    original: 990,
    discounted: 56,
    description: "Exclusive wooden Toy",
    categoryName: "toys",
  },
  {
    _id:"bb86bda0-a2c5-43e7-8c98-997ce95817fc",
    name: "Wind Chyme",
    image: image6,
    ratings: 4,
    price: 299,
    original: 1000,
    discounted: 70,
    description: "Exclusively from Gujrat",
    categoryName: "decorations",
  },
  {
    _id: "4ae7a696-fd18-4061-8309-f07002277bdc",
    name: "Basket",
    image: image8,
    ratings: 4,
    price: 99,
    original: 200,
    discounted: 50,
    description: "Environment Friendly Baskets",
    categoryName: "home",
  },
  {
    _id: "ebb61bb1-7cf9-4303-aab5-1015e213145d",
    name: "Wind Chyme",
    image: image9,
    ratings: 3.5,
    price: 390,
    original: 999,
    discounted: 75,
    description: "For your dream home",
    categoryName: "decorations",
  },
  {
    _id: "c0d14ede-8bd0-46fe-95e2-46baf3269107",
    name: "Marble Pot",
    image: image10,
    ratings: 5,
    price: 190,
    original: 500,
    discounted: 60,
    description: "Made from Marbles",
    categoryName: "decorations",
  },
  {
    _id: "49af1064-72d0-45f3-96a9-582d2742de6a",
    name: "4 mini decor set",
    image: item7,
    ratings: 4,
    price: 299,
    original: 499,
    discounted: 45,
    description: "Wild Artificial pot Plant ",
    categoryName: "home",
  },
  {
    _id: "d5c427cc-e05b-4075-ba46-8692c10cd8d7",
    name: "LED tree Lamp",
    image: item8,
    ratings: 4,
    price: 949,
    original: 1999,
    discounted: 50,
    description: "Pearl LED Lights for Home",
    categoryName: "home",
  },
  {
    _id: "6d511572-5acd-44fa-ba1c-5d5f75753e0e",
    name: "Horse Framed Art",
    image: item9,
    ratings: 5,
    price: 699,
    original: 1299,
    discounted: 50,
    description: "Arabian horses art",
    categoryName: "painting",
  },

];
